<template>
    <div class="order-detail-page">
        <div class="order-container scroll-container" ref="height_top" v-bind:style="{ height: tableHeight + 'px' }" style="overflow: auto;">

            <div class="order-section" style="padding-bottom: 0.5rem;padding-top: 0.5rem;">
                <div class="section-title" style="padding-bottom: 0rem;">订单号：{{ orderNo }}</div>
            </div>

            <!-- <div class="order-section">
                <div class="section-title">配送方式</div>
                <div class="delivery-method">
                    <el-radio-group v-model="deliveryMethod">
                        <el-radio value="express">
                            <div class="radio-content">
                                <span class="radio-icon"><svg t="1782196693161" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4895" width="32" height="32"><path d="M644.6 628c-47.3 0-85.5 38.3-85.5 85.6 0 47.1 38.2 85.5 85.5 85.5s85.5-38.3 85.5-85.5c-0.1-47.2-38.3-85.6-85.5-85.6z m0 128.4c-23.6 0-42.7-19.2-42.7-42.7 0-23.6 19.1-42.7 42.7-42.7s42.7 19.1 42.7 42.7c0 23.4-19.1 42.7-42.7 42.7z" fill="#00A9BA" p-id="4896"></path><path d="M0 656.1c0 22.8 18.5 41.2 41.2 41.2h44.1c8-54.7 55.1-96.7 112-96.7 56.7 0 103.9 42 111.8 96.7h223.6c8-54.7 55.1-96.7 111.8-96.7s103.9 42 111.8 96.7h55.2c22.8 0 41.2-18.5 41.2-41.2v-91.3H0v91.3z" fill="#626264" p-id="4897"></path><path d="M197.2 628c-47.1 0-85.5 38.3-85.5 85.6 0 47.1 38.3 85.5 85.5 85.5 47.3 0 85.6-38.3 85.6-85.5S244.5 628 197.2 628z m0 128.4c-23.5 0-42.7-19.2-42.7-42.7 0-23.6 19.2-42.7 42.7-42.7 23.6 0 42.7 19.1 42.7 42.7c0 23.4-19.1 42.7-42.7 42.7z" fill="#00A9BA" p-id="4898"></path><path d="M724.8 402.8l299.2-42.5-300.2-29.8 296.4-38.6-167.3-19.3v-6.5c0-22.8-18.5-41.2-41.2-41.2H339.8c-22.8 0-41.2 18.4-41.2 41.2v30.6h-81.8c-14.4 0-28.3 5.8-38.6 15.9l-162 160.2C5.9 483.2 0 497.2 0 511.9V542h852.9v-81l171.1-32.3-299.2-25.9z m-474.7 69c0 3.6-2.9 6.5-6.5 6.5H86.9c-5.8 0-8.7-7.1-4.4-11.1l126.8-121.1c1.2-1.1 2.9-1.8 4.5-1.8h29.8c3.6 0 6.5 2.9 6.5 6.5v121z" fill="#626264" p-id="4899"></path></svg></span>
                                <span>快递运输</span>
                            </div>
                        </el-radio>
                        <el-radio value="cod">
                            <div class="radio-content">
                                <span class="radio-icon"><svg t="1782196725739" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6263" width="32" height="32"><path d="M562.082909 780.939636c-41.332364-93.044364-19.176727-200.610909 55.994182-272.011636 75.170909-71.400727 188.416-92.439273 286.347636-53.154909 6.097455 2.420364 12.101818 5.12 17.966546 7.959273 3.118545 1.536 6.842182 1.396364 9.821091-0.325819a9.448727 9.448727 0 0 0 4.840727-8.145454V321.722182c0-39.796364-23.691636-76.148364-61.160727-93.928727l-129.861819-61.533091a10.519273 10.519273 0 0 0-9.076363 0L280.669091 387.490909a9.495273 9.495273 0 0 0-5.492364 8.517818v122.414546c0 3.211636-1.722182 6.237091-4.608 8.005818a10.519273 10.519273 0 0 1-9.588363 0.651636l-58.461091-25.227636a9.495273 9.495273 0 0 1-5.864728-8.704V362.682182c0-3.584 2.094545-6.842182 5.399273-8.517818l443.857455-218.344728a9.495273 9.495273 0 0 0 5.445818-8.564363 9.495273 9.495273 0 0 0-5.585455-8.471273l-127.488-60.369455a115.758545 115.758545 0 0 0-98.629818 0l-357.469091 169.425455C24.669091 245.620364 0.977455 282.065455 0.977455 321.815273v381.300363c0 39.796364 23.691636 76.148364 61.160727 93.928728l357.515636 169.378909a115.805091 115.805091 0 0 0 98.676364 0l132.654545-62.836364a9.541818 9.541818 0 0 0 5.492364-7.912727 9.402182 9.402182 0 0 0-4.282182-8.471273 252.229818 252.229818 0 0 1-90.158545-106.263273z" fill="#F7B500" p-id="6264"></path><path d="M802.722909 474.437818c-89.367273 0-169.937455 51.106909-204.148364 129.582546-34.210909 78.429091-15.36 168.773818 47.895273 228.817454 63.208727 60.043636 158.254545 78.010182 240.872727 45.474909 82.571636-32.488727 136.378182-109.056 136.378182-193.954909 0-55.668364-23.272727-109.102545-64.698182-148.48a227.048727 227.048727 0 0 0-156.299636-61.44z m104.029091 201.728v19.083637a10.146909 10.146909 0 0 1-10.705455 9.495272h-68.887272a2.56 2.56 0 0 0-2.653091 2.327273v15.173818c0.093091 1.303273 1.256727 2.327273 2.653091 2.327273h68.887272a10.146909 10.146909 0 0 1 10.65891 9.495273v19.037091a10.146909 10.146909 0 0 1-10.705455 9.541818h-68.840727a2.56 2.56 0 0 0-2.653091 2.327272v77.917091a10.146909 10.146909 0 0 1-10.705455 9.541819h-21.317818a10.146909 10.146909 0 0 1-10.705454-9.541819v-77.730909a2.56 2.56 0 0 0-2.653091-2.327272h-68.421819a10.146909 10.146909 0 0 1-10.705454-9.541819v-19.083636a10.146909 10.146909 0 0 1 10.705454-9.541818h68.421819c1.396364 0 2.606545-0.977455 2.699636-2.327273v-15.220364a2.56 2.56 0 0 0-2.699636-2.327272h-68.421819a10.146909 10.146909 0 0 1-10.705454-9.541818v-19.083637a10.146909 10.146909 0 0 1 10.705454-9.495273h31.418182c0.930909 0.093091 1.861818-0.372364 2.373818-1.163636a2.234182 2.234182 0 0 0-0.139636-2.56l-69.213091-94.114909a8.843636 8.843636 0 0 1-1.536-7.261091 9.216 9.216 0 0 1 4.608-6.004364l17.92-10.426181a11.496727 11.496727 0 0 1 14.661818 2.792727l86.481455 117.620364a2.792727 2.792727 0 0 0 2.234182 1.11709h6.376727a2.792727 2.792727 0 0 0 2.234182-1.11709l86.528-117.620364a11.496727 11.496727 0 0 1 14.754909-2.792727l17.873454 10.426181c2.327273 1.303273 4.002909 3.444364 4.561455 5.957819a8.843636 8.843636 0 0 1-1.489455 7.214545L861.090909 662.900364a2.234182 2.234182 0 0 0-0.139636 2.513454c0.465455 0.791273 1.396364 1.256727 2.327272 1.163637h32.67491a10.705455 10.705455 0 0 1 7.447272 2.699636 9.634909 9.634909 0 0 1 3.258182 6.888727z" fill="#F7B500" p-id="6265"></path></svg></span>
                                <span>到付</span>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div> -->

            <div class="order-section">
                <div class="section-title">收货地址</div>
                <div class="address-display" @click="openAddressDialog">
                    <el-icon class="edit-icon"><Edit /></el-icon>
                    <el-icon class="address-icon"><LocationFilled /></el-icon>
                    <template v-if="selectedAddress">
                        <div class="address-content">
                            <span class="address-name">{{ selectedAddress.name }} {{ selectedAddress.phone }}</span>
                            <span class="address-detail-text">{{ selectedAddress.province }}{{ selectedAddress.city }}{{ selectedAddress.district }}{{ selectedAddress.detail }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <span class="address-placeholder">请选择收货地址</span>
                    </template>
                </div>
            </div>

            <div class="order-section">
                <div class="section-title">购买清单</div>
                <div class="purchase-list">
                    <div  >
                        <el-table   :data="tableData"
                            :header-cell-style="{ 'background-color': '#e5e5e5' }" size="small" v-loading="loading"
                            style="width: 100%;">
                            <el-table-column prop="img" label="实图" width="100" header-align="center"
                                show-overflow-tooltip>
                                <template #default="scope">
                                    <div v-if="scope.row.img.length <= 0">
                                        <div @click="preview(scope.row, scope.row.img)">
                                            <el-image style="" :src="require('@/assets/img/error_img.png')"
                                                loading="lazy" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div @click="preview(scope.row, scope.row.img)">
                                            <el-image :src="scope.row.img[0]" loading="lazy" />
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="stock_type_txt" label="货物状态" header-align="center" width="170"
                                show-overflow-tooltip>
                                <template #default="scope">
                                    <div class="stock_type_txt_button">
                                        <span v-for="item in scope.row.stock_type_txt_list">
                                            <el-button class="A" size="small" text bg
                                                v-if="item == '二手' || item == '过保' || item == '包附破损'" style="">{{ item
                                                }}</el-button>
                                            <el-button class="C" size="small" text bg v-else color="#ff8a5c">{{
                                                item }}</el-button>
                                        </span>
                                    </div>
                                    <!-- <el-button-group class="ml-4">
										    <el-button size="small"/>
										    <el-button size="small" />
										    <el-button size="small" />
										  </el-button-group> -->
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="brand_name" label="产品信息" show-overflow-tooltip>
                                <template #default="scope">
                                    <div class="product-info">
                                        <div class="brand-name" v-if="scope.row.product_brand_name">
                                            {{ scope.row.product_brand_name }}
                                        </div>
                                        <div class="product-name" v-if="scope.row.product_name">
                                            {{ scope.row.product_name }}
                                        </div>
                                        <div class="product-details" v-if="scope.row.product_model">
                                            <span class="detail-label">型号</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.product_model }}</span>
                                        </div>
                                        <div class="product-details" v-if="scope.row.product_order_no">
                                            <span class="detail-label">订货号</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.product_order_no }}</span>
                                        </div>
                                        <div class="product-details" v-if="scope.row.unit">
                                            <span class="detail-label">单位</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.unit }}</span>
                                        </div>
                                        <div class="product-user-type" v-if="scope.row.product_type_name">
                                            <span class="detail-label">用户类型</span><span class="label-colon">：</span>
                                            <span class="detail-value">{{ scope.row.product_type_name }}</span>
                                        </div>
                                        <span
                                            v-if="!scope.row.product_brand_name && !scope.row.product_name && !scope.row.product_model && !scope.row.product_order_no">
                                            -
                                        </span>

                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="tsw_price" align="center" header-align="center" label="单价"
                                :width="td_width['tsw_price']" show-overflow-tooltip>

                                <template #default="scope">
                                    <el-tooltip placement="top">
                                        <template #content>
                                            <p>此信息由用户提供</p>
                                            
                                        </template>
                                        <span class="price-value">{{ scope.row.price }}</span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="num" label="数量" width="230" align="center"
                                header-align="center" show-overflow-tooltip>

                            </el-table-column>
                            <el-table-column prop="" label="" width="20" />
                            <el-table-column prop="tsw_price" align="center" header-align="center" label="金额"
                                :width="td_width['tsw_price']" show-overflow-tooltip>
                                <template #default="scope">
                                    <span class="price-value">{{ scope.row.sum }}</span>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>
                </div>
            </div>

            <div class="order-section">
                <div class="section-title">订单备注</div>
                <div class="remark-section">
                    <el-input v-model="orderRemark" type="textarea" :rows="3" placeholder="请输入订单备注（选填）" resize="none" />
                </div>
            </div>

            <div class="order-section">
                <div class="section-title">订单详情</div>
                <div class="order-summary">
                    <div class="summary-item">
                        <span class="summary-label">商品数量：</span>
                        <span class="summary-value">{{ totalQuantity }} 件</span>
                    </div>
                    <div class="summary-item" v-if="deliveryMethod === 'express'">
                        <span class="summary-label">快递费用：</span>
                        <span class="summary-value">¥{{ shippingFee.toFixed(2) }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="summary-label">商品金额：</span>
                        <span class="summary-value">¥{{ totalAmount.toFixed(2) }}</span>
                    </div>
                    <div class="summary-item" v-if="goodsDiscount > 0">
                        <span class="summary-label">优惠金额：</span>
                        <span class="summary-value discount">
                            <el-tag type="danger" size="small" effect="dark">省</el-tag>
                            ¥{{ goodsDiscount.toFixed(2) }}
                        </span>
                    </div>
                    <div class="summary-divider"></div>
                    <div class="summary-item total-item">
                        <span class="summary-label">合计：</span>
                        <span class="summary-value total-value">¥{{ finalTotal.toFixed(2) }}</span>
                    </div>
                    <div v-if="selectedAddress" class="summary-item">
                        <span class="summary-label">联系人：</span>
                        <span class="summary-value">{{ selectedAddress.name }}</span>
                    </div>
                    <div v-if="selectedAddress" class="summary-item">
                        <span class="summary-label">联系电话：</span>
                        <span class="summary-value">{{ selectedAddress.phone }}</span>
                    </div>
                    <div v-if="selectedAddress" class="summary-item address-summary">
                        <span class="summary-label">收货地址：</span>
                        <span class="summary-value address-text">{{ selectedAddress.province }}{{
                            selectedAddress.city }}{{ selectedAddress.district }}{{
                                selectedAddress.detail }}</span>
                    </div>
                </div>
            </div>

            <div class="order-section">
                <div class="section-title">支付方式</div>
                <div class="payment-method">
                    <el-radio-group v-model="paymentMethod">
                        <el-radio value="wechat">
                            <div class="radio-content">
                                <span class="radio-icon wechat"><svg t="1782196919523" class="icon" viewBox="0 0 1228 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7334" width="32" height="32"><path d="M530.8928 703.1296a41.472 41.472 0 0 1-35.7376-19.8144l-2.7136-5.5808L278.272 394.752a18.7392 18.7392 0 0 1-2.048-8.1408 19.968 19.968 0 0 1 20.48-19.3536c4.608 0 8.8576 1.4336 12.288 3.84l234.3936 139.9296a64.4096 64.4096 0 0 0 54.528 5.9392L1116.2624 204.8C1004.9536 80.896 821.76 0 614.4 0 275.0464 0 0 216.576 0 483.6352c0 145.7152 82.7392 276.8896 212.2752 365.5168a38.1952 38.1952 0 0 1 17.2032 31.488 44.4928 44.4928 0 0 1-2.1504 12.3904l-27.6992 97.4848c-1.3312 4.608-3.328 9.3696-3.328 14.1312 0 10.752 9.216 19.3536 20.48 19.3536 4.4032 0 8.0384-1.536 11.776-3.584l134.5536-73.3184c10.1376-5.5296 20.7872-8.96 32.6144-8.96 6.2976 0 12.288 0.9216 18.0736 2.5088 62.72 17.0496 130.4576 26.5728 200.5504 26.5728C953.7024 967.168 1228.8 750.592 1228.8 483.6352c0-80.9472-25.4464-157.1328-70.0416-224.1024l-604.9792 436.992-4.4544 2.4064a42.1376 42.1376 0 0 1-18.432 4.1984z" fill="#15BA11" p-id="7335"></path></svg></span>
                                <span>微信支付</span>
                            </div>
                        </el-radio>
                        <el-radio value="alipay">
                            <div class="radio-content">
                                <span class="radio-icon alipay"><svg t="1782196955819" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8421" width="32" height="32"><path d="M1024.0512 701.0304V196.864A196.9664 196.9664 0 0 0 827.136 0H196.864A196.9664 196.9664 0 0 0 0 196.864v630.272A196.9152 196.9152 0 0 0 196.864 1024h630.272a197.12 197.12 0 0 0 193.8432-162.0992c-52.224-22.6304-278.528-120.32-396.4416-176.64-89.7024 108.6976-183.7056 173.9264-325.3248 173.9264s-236.1856-87.2448-224.8192-194.048c7.4752-70.0416 55.552-184.576 264.2944-164.9664 110.08 10.3424 160.4096 30.8736 250.1632 60.5184 23.1936-42.5984 42.496-89.4464 57.1392-139.264H248.064v-39.424h196.9152V311.1424H204.8V267.776h240.128V165.632s2.1504-15.9744 19.8144-15.9744h98.4576V267.776h256v43.4176h-256V381.952h208.8448a805.9904 805.9904 0 0 1-84.8384 212.6848c60.672 22.016 336.7936 106.3936 336.7936 106.3936zM283.5456 791.6032c-149.6576 0-173.312-94.464-165.376-133.9392 7.8336-39.3216 51.2-90.624 134.4-90.624 95.5904 0 181.248 24.4736 284.0576 74.5472-72.192 94.0032-160.9216 150.016-253.0816 150.016z" fill="#009FE8" p-id="8422"></path></svg></span>
                                <span>支付宝</span>
                            </div>
                        </el-radio>
                        <el-radio value="dg">
                            <div class="radio-content">
                                <span class="radio-icon alipay"><svg t="1782956459275" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6489" width="32" height="32"><path d="M512 0c282.752 0 512 229.248 512 512S794.752 1024 512 1024 0 794.752 0 512 229.248 0 512 0z m315.0464 455.0784H214.144v237.7472a75.264 75.264 0 0 0 15.9616 47.232l4.8128 5.5424A71.9232 71.9232 0 0 0 286.208 768h468.8256a72.1536 72.1536 0 0 0 51.2768-22.3616 75.0976 75.0976 0 0 0 20.736-52.8128V455.0784zM550.4896 623.744l-36.2752 72.1024H478.848l37.12-72.1024h34.5216z m76.7104 0l-34.56 72.1024h-35.3664l35.4048-72.1024H627.2z m143.1936 0l-35.84 72.1024h-100.5312L668.16 623.744h102.272-0.0384z m-15.36-325.0816h-469.248a73.6384 73.6384 0 0 0-71.6032 75.1872L214.144 416h612.9024v-42.1504a75.0464 75.0464 0 0 0-15.9104-47.232l-4.8256-5.5552a72.192 72.192 0 0 0-51.2768-22.4z" fill="#FC5330" p-id="6490"></path></svg></span>
                                <span>对公支付</span>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div class="order-footer">
                <div class="footer-left">
                    <div class="total-display">
                        <span class="total-label">应付总额：</span>
                        <span class="total-amount">¥{{ finalTotal.toFixed(2) }}</span>
                    </div>
                </div>
                <div class="footer-right">
                    <el-button class="delete-btn" @click="handleDeleteOrder">取消订单</el-button>
                    <el-button type="primary" class="pay-btn" @click="handlePay">去支付</el-button>
                </div>
            </div>
        </div>

        <el-dialog v-model="showAddAddress" :close-on-click-modal="false" :close-on-press-escape="false" :title="editingAddressIndex >= 0 ? '修改地址' : '新增地址'" width="500px">
            <el-form :model="newAddress" label-width="80px">
                <el-form-item label="收货人">
                    <el-input v-model="newAddress.name" placeholder="请输入收货人姓名" />
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="newAddress.phone" placeholder="请输入手机号" />
                </el-form-item>
                <el-form-item label="所在地区">
                    <el-select v-model="newAddress.province_code" placeholder="省" style="width: 32%; margin-right: 2%;" @change="handleProvinceChange">
                        <el-option v-for="province in areaData" :key="province.code" :label="province.name" :value="province.code" />
                    </el-select>
                    <el-select v-model="newAddress.city_code" placeholder="市" style="width: 31%; margin-right: 2%;" @change="handleCityChange">
                        <el-option v-for="city in cityList" :key="city.code" :label="city.name" :value="city.code" />
                    </el-select>
                    <el-select v-model="newAddress.district_code" placeholder="区" style="width: 33%;" @change="handleDistrictChange">
                        <el-option v-for="district in districtList" :key="district.code" :label="district.name" :value="district.code" />
                    </el-select>
                </el-form-item>
                <el-form-item label="详细地址">
                    <el-input v-model="newAddress.detail" type="textarea" :rows="2" placeholder="请输入详细地址" />
                </el-form-item>
                <el-form-item label="设为默认">
                    <el-switch v-model="newAddress.isDefault" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="showAddAddress = false">取消</el-button>
                <el-button type="primary" @click="saveAddress">保存</el-button>
            </template>
        </el-dialog>

        <el-dialog v-model="showPayDialog" title="确认支付" width="520px" :close-on-click-modal="false" custom-class="confirm-pay-dialog" top="5vh">
            <div class="pay-dialog-content">
                <div class="dialog-section">
                    <div class="dialog-section-title">订单信息</div>
                    <div class="order-info-block">
                        <div class="info-row">
                            <span class="info-label">订单号：</span>
                            <span class="info-value order-no">{{ orderNo }}</span>
                        </div>
                        <div class="info-row total-row">
                            <span class="info-label">应付金额：</span>
                            <span class="info-value total-price">¥{{ finalTotal.toFixed(2) }}</span>
                        </div>
                    </div>
                </div>
                
                <div class="dialog-section">
                    <div class="dialog-section-title">支付方式</div>
                     <div class="payment-method">
                    <el-radio-group v-model="paymentMethod">
                        <el-radio value="wechat">
                            <div class="radio-content">
                                <span class="radio-icon wechat"><svg t="1782196919523" class="icon" viewBox="0 0 1228 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7334" width="32" height="32"><path d="M530.8928 703.1296a41.472 41.472 0 0 1-35.7376-19.8144l-2.7136-5.5808L278.272 394.752a18.7392 18.7392 0 0 1-2.048-8.1408 19.968 19.968 0 0 1 20.48-19.3536c4.608 0 8.8576 1.4336 12.288 3.84l234.3936 139.9296a64.4096 64.4096 0 0 0 54.528 5.9392L1116.2624 204.8C1004.9536 80.896 821.76 0 614.4 0 275.0464 0 0 216.576 0 483.6352c0 145.7152 82.7392 276.8896 212.2752 365.5168a38.1952 38.1952 0 0 1 17.2032 31.488 44.4928 44.4928 0 0 1-2.1504 12.3904l-27.6992 97.4848c-1.3312 4.608-3.328 9.3696-3.328 14.1312 0 10.752 9.216 19.3536 20.48 19.3536 4.4032 0 8.0384-1.536 11.776-3.584l134.5536-73.3184c10.1376-5.5296 20.7872-8.96 32.6144-8.96 6.2976 0 12.288 0.9216 18.0736 2.5088 62.72 17.0496 130.4576 26.5728 200.5504 26.5728C953.7024 967.168 1228.8 750.592 1228.8 483.6352c0-80.9472-25.4464-157.1328-70.0416-224.1024l-604.9792 436.992-4.4544 2.4064a42.1376 42.1376 0 0 1-18.432 4.1984z" fill="#15BA11" p-id="7335"></path></svg></span>
                                <span>微信支付</span>
                            </div>
                        </el-radio>
                        <el-radio value="alipay">
                            <div class="radio-content">
                                <span class="radio-icon alipay"><svg t="1782196955819" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8421" width="32" height="32"><path d="M1024.0512 701.0304V196.864A196.9664 196.9664 0 0 0 827.136 0H196.864A196.9664 196.9664 0 0 0 0 196.864v630.272A196.9152 196.9152 0 0 0 196.864 1024h630.272a197.12 197.12 0 0 0 193.8432-162.0992c-52.224-22.6304-278.528-120.32-396.4416-176.64-89.7024 108.6976-183.7056 173.9264-325.3248 173.9264s-236.1856-87.2448-224.8192-194.048c7.4752-70.0416 55.552-184.576 264.2944-164.9664 110.08 10.3424 160.4096 30.8736 250.1632 60.5184 23.1936-42.5984 42.496-89.4464 57.1392-139.264H248.064v-39.424h196.9152V311.1424H204.8V267.776h240.128V165.632s2.1504-15.9744 19.8144-15.9744h98.4576V267.776h256v43.4176h-256V381.952h208.8448a805.9904 805.9904 0 0 1-84.8384 212.6848c60.672 22.016 336.7936 106.3936 336.7936 106.3936zM283.5456 791.6032c-149.6576 0-173.312-94.464-165.376-133.9392 7.8336-39.3216 51.2-90.624 134.4-90.624 95.5904 0 181.248 24.4736 284.0576 74.5472-72.192 94.0032-160.9216 150.016-253.0816 150.016z" fill="#009FE8" p-id="8422"></path></svg></span>
                                <span>支付宝</span>
                            </div>
                        </el-radio>
                        <el-radio value="dg">
                            <div class="radio-content">
                                <span class="radio-icon alipay"><svg t="1782956459275" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6489" width="32" height="32"><path d="M512 0c282.752 0 512 229.248 512 512S794.752 1024 512 1024 0 794.752 0 512 229.248 0 512 0z m315.0464 455.0784H214.144v237.7472a75.264 75.264 0 0 0 15.9616 47.232l4.8128 5.5424A71.9232 71.9232 0 0 0 286.208 768h468.8256a72.1536 72.1536 0 0 0 51.2768-22.3616 75.0976 75.0976 0 0 0 20.736-52.8128V455.0784zM550.4896 623.744l-36.2752 72.1024H478.848l37.12-72.1024h34.5216z m76.7104 0l-34.56 72.1024h-35.3664l35.4048-72.1024H627.2z m143.1936 0l-35.84 72.1024h-100.5312L668.16 623.744h102.272-0.0384z m-15.36-325.0816h-469.248a73.6384 73.6384 0 0 0-71.6032 75.1872L214.144 416h612.9024v-42.1504a75.0464 75.0464 0 0 0-15.9104-47.232l-4.8256-5.5552a72.192 72.192 0 0 0-51.2768-22.4z" fill="#FC5330" p-id="6490"></path></svg></span>
                                <span>对公支付</span>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
                    <div class="payment-info-block" v-if="paymentMethod === 'dg'">
                        
                        <!-- 对公支付账户信息 -->
                        <div class="corporate-info">
                            <div class="corporate-title">对公账户信息</div>
                            <div class="corporate-row">
                                <span class="corporate-label">开户银行：</span>
                                <span class="corporate-value">{{ corporateAccount.bankName }}</span>
                            </div>
                            <div class="corporate-row">
                                <span class="corporate-label">账户名称：</span>
                                <span class="corporate-value">{{ corporateAccount.accountName }}</span>
                            </div>
                            <div class="corporate-row">
                                <span class="corporate-label">银行账号：</span>
                                <span class="corporate-value">{{ corporateAccount.accountNumber }}</span>
                            </div>
                            <div class="corporate-divider"></div>
                            <div class="transfer-info-title">付款信息</div>
                            <div class="transfer-info-row">
                                <span class="transfer-label"><span class="required">*</span>付款公司名称：</span>
                                <el-input v-model="transferInfo.companyName" placeholder="请输入付款公司名称" class="transfer-input"></el-input>
                            </div>
                            <div class="transfer-info-row">
                                <span class="transfer-label"><span class="required">*</span>付款金额：</span>
                                <el-input v-model="transferInfo.paymentAmount" placeholder="付款金额（两位小数且与订单金额一致）" type="text" class="transfer-input" @input="validatePaymentAmount"></el-input>
                            </div>
                            <div class="transfer-info-row">
                                <span class="transfer-label">付款凭证：</span>
                                <el-upload
                                    class="voucher-uploader"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="handleVoucherChange"
                                    :on-remove="handleVoucherRemove"
                                    :on-exceed="handleVoucherExceed"
                                    :file-list="paymentVoucherList"
                                    :limit="1"
                                    accept="image/jpeg,image/png,image/webp,image/gif"
                                    list-type="picture-card">
                                    <el-icon class="voucher-uploader-icon"><Plus /></el-icon>
                                </el-upload>
                            </div>
                            <div class="transfer-tip">注：本笔订单交易金额及明细将会根据付款公司进行开具增值税发票。</div>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- <el-button @click="showPayDialog = false">取消</el-button> -->
                <el-button type="primary" class="confirm-pay-btn" :loading="confirmPayLoading" @click="confirmPay">确认支付</el-button>
            </template>
        
        </el-dialog>

        <!-- 对公支付账户信息弹窗 -->
        <el-dialog v-model="showCorporateInfoDialog" :close-on-press-escape="false" title="对公支付" :close-on-click-modal="false" :show-close="false" width="660px">
            <div class="corporate-info-dialog">
                <div class="success-icon">✅</div>
                <div class="success-message">订单提交成功</div>
                <div class="corporate-info-section">
                    <div class="corporate-title">对公账户信息</div>
                    <div class="corporate-row">
                        <span class="corporate-label">开户银行：</span>
                        <span class="corporate-value">{{ corporateAccount.bankName }}</span>
                    </div>
                    <div class="corporate-row">
                        <span class="corporate-label">账户名称：</span>
                        <span class="corporate-value">{{ corporateAccount.accountName }}</span>
                    </div>
                    <div class="corporate-row">
                        <span class="corporate-label">银行账号：</span>
                        <span class="corporate-value">{{ corporateAccount.accountNumber }}</span>
                    </div>
                </div>
                <div class="corporate-divider"></div>
                <div class="transfer-info-section">
                    <div class="transfer-title">付款信息</div>
                    <div class="transfer-row">
                        <span class="transfer-label">付款公司名称：</span>
                        <span class="transfer-value">{{ transferInfo.companyName }}</span>
                    </div>
                    <div class="transfer-row">
                        <span class="transfer-label">付款金额：</span>
                        <span class="transfer-value">¥{{ transferInfo.paymentAmount }}</span>
                    </div>
                </div>
               
            </div>
            <template #footer>
                <el-button type="primary" class="confirm-pay-btn" @click="showCorporateInfoDialog = false; $router.push('/user?type=orderList')">确定</el-button>
            </template>
        </el-dialog>

        <!-- 微信支付弹窗 -->
        <el-dialog v-model="showWechatPayDialog" :close-on-press-escape="false" title="微信支付" :close-on-click-modal="false" :show-close="false" width="460px">
            <div class="wechat-pay-dialog">
                <div class="wechat-header">
                    <div class="wechat-icon">
                        <svg t="1782196919523" class="icon" viewBox="0 0 1228 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7334" width="48" height="48"><path d="M530.8928 703.1296a41.472 41.472 0 0 1-35.7376-19.8144l-2.7136-5.5808L278.272 394.752a18.7392 18.7392 0 0 1-2.048-8.1408 19.968 19.968 0 0 1 20.48-19.3536c4.608 0 8.8576 1.4336 12.288 3.84l234.3936 139.9296a64.4096 64.4096 0 0 0 54.528 5.9392L1116.2624 204.8C1004.9536 80.896 821.76 0 614.4 0 275.0464 0 0 216.576 0 483.6352c0 145.7152 82.7392 276.8896 212.2752 365.5168a38.1952 38.1952 0 0 1 17.2032 31.488 44.4928 44.4928 0 0 1-2.1504 12.3904l-27.6992 97.4848c-1.3312 4.608-3.328 9.3696-3.328 14.1312 0 10.752 9.216 19.3536 20.48 19.3536 4.4032 0 8.0384-1.536 11.776-3.584l134.5536-73.3184c10.1376-5.5296 20.7872-8.96 32.6144-8.96 6.2976 0 12.288 0.9216 18.0736 2.5088 62.72 17.0496 130.4576 26.5728 200.5504 26.5728C953.7024 967.168 1228.8 750.592 1228.8 483.6352c0-80.9472-25.4464-157.1328-70.0416-224.1024l-604.9792 436.992-4.4544 2.4064a42.1376 42.1376 0 0 1-18.432 4.1984z" fill="#15BA11" p-id="7335"></path></svg>
                    </div>
                    <div class="wechat-title">请使用微信扫码支付</div>
                </div>
                <div class="amount-section">
                    <div class="amount-label">支付金额</div>
                    <div class="amount-value">¥{{ wechatPayAmount.toFixed(2) }}</div>
                </div>
                <div class="qrcode-section">
                    <div class="qrcode-wrapper">
                        <qrcode-vue :value="wechatPayUrl" :size="220" level="H" />
                    </div>
                    <div class="qrcode-tip">请使用微信扫描二维码</div>
                </div>
                <div class="order-info-section">
                    <div class="order-info-row">
                        <span class="order-info-label">订单号：</span>
                        <span class="order-info-value">{{ orderNo }}</span>
                    </div>
                </div>
            </div>
            <template #footer>
                <el-button @click="closeWechatPayDialog">取消支付</el-button>
                <el-button type="primary" class="confirm-pay-btn" @click="checkWechatPayment">我已支付完成</el-button>
            </template>
        </el-dialog>
    </div>
    <examineImg ref="examineImg"></examineImg>

    <!-- 地址选择弹窗 -->
    <el-dialog v-model="showAddressDialog" :close-on-click-modal="false" :close-on-press-escape="false" title="选择收货地址" width="600px">
        <div class="address-list">
            <div v-for="(addr, index) in addressList" :key="index" class="address-item"
                :class="{ active: selectedAddressIndex === index }" @click="selectAddress(index)">
                <div class="address-info">
                    <div class="address-info-left">
                        <span class="address-name">{{ addr.name }}</span>
                        <span class="address-phone">{{ addr.phone }}</span>
                    </div>
                    <div class="action-buttons">
                        <el-button size="small" type="primary" @click.stop="editAddress(index)" class="edit-btn" icon="Edit"></el-button>
                        <el-button size="small" type="danger" @click.stop="deleteAddress(index)" class="delete-btn" icon="Delete"></el-button>
                    </div>
                </div>
                <div class="address-detail">{{ addr.province }}{{ addr.city }}{{ addr.district }}{{ addr.detail }}</div>
                <div class="address-actions">
                    <div v-if="addr.isDefault" class="default-tag">默认</div>
                </div>
            </div>
            <div v-if="addressList.length === 0" class="no-address-tip">
                <el-icon><Plus /></el-icon>
                <span>暂无收货地址，请点击下方按钮添加</span>
            </div>
        </div>
        <div class="add-address-btn" @click="openAddAddress">
            <el-icon><Plus /></el-icon>
            <span>新增地址</span>
        </div>
        <template #footer>
            <el-button @click="showAddressDialog = false">取消</el-button>
            <el-button type="primary" @click="confirmAddress">确认选择</el-button>
        </template>
    </el-dialog>

    <!-- 新增/修改地址弹窗 -->
    <el-dialog v-model="showAddAddress" :close-on-click-modal="false" :close-on-press-escape="false" :title="editingAddressIndex >= 0 ? '修改地址' : '新增地址'" width="500px">
        <el-form :model="newAddress" label-width="80px">
            <el-form-item label="收货人">
                <el-input v-model="newAddress.name" placeholder="请输入收货人姓名" />
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="newAddress.phone" placeholder="请输入手机号" />
            </el-form-item>
            <el-form-item label="所在地区">
                <el-select v-model="newAddress.province_code" placeholder="省" style="width: 32%; margin-right: 2%;" @change="handleProvinceChange">
                    <el-option v-for="province in areaData" :key="province.code" :label="province.name" :value="province.code" />
                </el-select>
                <el-select v-model="newAddress.city_code" placeholder="市" style="width: 31%; margin-right: 2%;" @change="handleCityChange">
                    <el-option v-for="city in cityList" :key="city.code" :label="city.name" :value="city.code" />
                </el-select>
                <el-select v-model="newAddress.district_code" placeholder="区" style="width: 33%;" @change="handleDistrictChange">
                    <el-option v-for="district in districtList" :key="district.code" :label="district.name" :value="district.code" />
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址">
                <el-input v-model="newAddress.detail" type="textarea" :rows="2" placeholder="请输入详细地址" />
            </el-form-item>
            <el-form-item label="设为默认">
                <el-switch v-model="newAddress.isDefault" />
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="showAddAddress = false">取消</el-button>
            <el-button type="primary" @click="saveAddress">保存</el-button>
        </template>
    </el-dialog>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { Plus, LocationFilled, Edit, Delete } from '@element-plus/icons-vue'
import '../../assets/user/index.css'
import areaData from '../../assets/data/area.json'
import examineImg from '../public/img';
export default {
    components: { Plus, examineImg, LocationFilled, Edit, Delete },
    data() {

        return {
            areaData,
            cityList: [],
            districtList: [],
            SelectionChangeId: [],
            tableData: [],
            form: {
                name: '',
                userinfo: '',
                type: '',
            },
            loading: false,
            total: 0,
            page: 1,
            tableHeight: 400,
            page_size: 120,
            user_id: '',
            td_width: {
                brand_name: 300,
                tsw_price: 180,
                sur_num: 180,
                chat: 60,
                price: 80
            },
            orderNo: 'ORD' + Date.now(),
            orderTime: new Date().toLocaleString('zh-CN'),
            deliveryMethod: 'express',
            paymentMethod: 'wechat',
            corporateAccount: {
                bankName: '',
                accountName: '',
                accountNumber: ''
            },
            transferInfo: {
                companyName: '',
                paymentAmount: ''
            },
            paymentVoucherList: [],
            orderRemark: '',
            shippingFee: 0,
            totalQuantity: 0,
            totalAmount: 0,
            totalSum: 0,
            goodsDiscount: 0,
            showAddAddress: false,
            showAddressDialog: false,
            showPayDialog: false,
            showCorporateInfoDialog: false,
            showWechatPayDialog: false,
            confirmPayLoading: false,
            selectedAddressIndex: 0,
            editingAddressIndex: -1,
            address_id: '',
            wechatPayUrl: '',
            wechatPayAmount: 0,
            paymentPollingTimer: null,

            srcList: [],
            addressList: [
               
            ],
            newAddress: {
                name: '',
                phone: '',
                province: '',
                province_code: '',
                city: '',
                city_code: '',
                district: '',
                district_code: '',
                detail: '',
                isDefault: false
            }

        }
    },
    props: [],

    updated() {

    },


    mounted() {
    },
    beforeDestroy() {
        this.clearPaymentPolling();
    },

    activated() {

    },
    created() {
        this.tableHeight_fun()
        this.user_id = localStorage.getItem('user_id');
        this.initData()
    },
    watch: {

    },
    computed: {
        finalTotal() {
            if (this.deliveryMethod === 'cod') {
                return this.totalSum
            }
            return this.totalSum + this.shippingFee
        },
        selectedAddress() {
            if (this.addressList.length > 0 && this.selectedAddressIndex >= 0 && this.selectedAddressIndex < this.addressList.length) {
                return this.addressList[this.selectedAddressIndex]
            }
            return null
        }
    },
    methods: {
        async initData() {
            try {
                // 等待订单详情和地址列表两个接口都请求成功
                const [searchRes, addressRes] = await Promise.all([
                    this.search(),
                    this.getAddressList()
                ]);
                
                // 两个接口都成功后，使用订单的address_id设置默认地址
                this.setDefaultAddressByOrderId()
            } catch (err) {
                console.error('初始化数据失败:', err)
            }
        },
        setDefaultAddressByOrderId() {
            if (this.addressList.length > 0 && this.address_id) {
                const addressIndex = this.addressList.findIndex(addr => Number(addr.id) === Number(this.address_id))
                if (addressIndex >= 0) {
                    this.selectedAddressIndex = addressIndex
                    return
                }
            }
            // 没有匹配的订单地址，使用默认地址
            if (this.addressList.length > 0) {
                const defaultIndex = this.addressList.findIndex(addr => addr.isDefault)
                this.selectedAddressIndex = defaultIndex >= 0 ? defaultIndex : 0
            }
        },
        async handleDeleteOrder() {
            try {
                await ElMessageBox.confirm('确认取消订单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                
                const res = await this.$axios.post('/api/yunsys.Order/cancelbills', {
                    pay_no: this.orderNo
                })
                
                const data = res.data
                if (data.code === 0) {
                    ElMessage.success('取消成功')
                    this.$router.push('/user?type=orderList')
                } else {
                    ElMessage.error(data.msg || '取消失败')
                }
            } catch (err) {
                if (err !== 'cancel') {
                    console.error('取消订单失败:', err)
                    ElMessage.error('系统错误')
                }
            }
        },

        preview(row, img) {
            this.srcList = [];
            var obj = this;
            if (img) {
                img.forEach(function (item) {
                    obj.srcList.push(item)
                })
            }
            this.$refs['examineImg'].img_title = row;
            this.$refs['examineImg'].data = this.srcList;
            this.$refs['examineImg'].dialogTableVisible = true;
            this.$refs['examineImg'].imgBigUrl = this.srcList[0];
        },

        handleChange(row) {
            if (row && row.num_input && row.tsw_price) {
                row.tsw_money = this.$bn.multiply(row.num_input, row.tsw_price, 2);
            }
        },
        selectAddress(index) {
            this.selectedAddressIndex = index
        },
        openAddressDialog() {
            this.showAddressDialog = true
        },
        confirmAddress() {
            if (this.selectedAddressIndex < 0) {
                ElMessage.warning('请选择收货地址')
                return
            }
            this.showAddressDialog = false
        },
        validatePaymentAmount(value) {
            const regex = /^\d+(\.\d{0,2})?$/;
            if (value && !regex.test(value)) {
                this.transferInfo.paymentAmount = value.replace(/[^\d.]/g, '').replace(/(\.\d{2})\d+$/, '$1');
            }
        },
        handleVoucherChange(file, fileList) {
            const isImage = file.raw && (file.raw.type === 'image/jpeg' || file.raw.type === 'image/png' || file.raw.type === 'image/webp' || file.raw.type === 'image/gif');
            if (!isImage) {
                ElMessage.error('只能上传图片格式文件（JPG/PNG/WEBP/GIF）！');
                this.paymentVoucherList = fileList.filter(item => item.uid !== file.uid);
                return;
            }
            const isLt2M = file.raw.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                ElMessage.error('上传图片大小不能超过 2MB！');
                this.paymentVoucherList = fileList.filter(item => item.uid !== file.uid);
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file.raw);
            reader.onload = (e) => {
                file.url = e.target.result;
                this.paymentVoucherList = fileList.map(item => ({
                    name: item.name,
                    url: item.url,
                    uid: item.uid,
                    status: item.status
                }));
            };
            reader.onerror = () => {
                ElMessage.error('图片解析失败，请重新上传！');
                this.paymentVoucherList = fileList.filter(item => item.uid !== file.uid);
            };
        },
        handleVoucherRemove(file, fileList) {
            this.paymentVoucherList = fileList.map(item => ({
                name: item.name,
                url: item.url,
                uid: item.uid,
                status: item.status
            }));
        },
        handleVoucherExceed() {
            ElMessage.warning('当前只能上传一个付款凭证，请先删除已有凭证再重新上传！');
        },
        handleProvinceChange(provinceCode, shouldReset = true) {
            if (shouldReset) {
                // this.newAddress.city = ''
                // this.newAddress.city_code = ''
                // this.newAddress.district = ''
                // this.newAddress.district_code = ''
                this.districtList = []
            }
            const province = this.areaData.find(item => item.code === provinceCode)
            if (province) {
                if (shouldReset) this.newAddress.province = province.name
                this.cityList = province.children || []
                
            } else {
                if (shouldReset) this.newAddress.province = ''
                this.cityList = []
            }
        },
        handleCityChange(cityCode, shouldReset = true) {
            if (shouldReset) {
                // this.newAddress.district = ''
                // this.newAddress.district_code = ''
            }
            const province = this.areaData.find(item => item.code === this.newAddress.province_code)
            if (province) {
                
                const city = province.children.find(item => item.code === cityCode)
                
                if (city) {
                    if (shouldReset) this.newAddress.city = city.name
                    this.districtList = city.children || []
                    
                } else {
                    if (shouldReset) this.newAddress.city = ''
                    this.districtList = []
                }
            } else {
                this.districtList = []
            }
        },
        handleDistrictChange(districtCode) {
            const province = this.areaData.find(item => item.code === this.newAddress.province_code)
            if (province) {
                const city = province.children.find(item => item.code === this.newAddress.city_code)
                if (city) {
                    const district = city.children.find(item => item.code === districtCode)
                    if (district) {
                        this.newAddress.district = district.name
                    } else {
                        this.newAddress.district = ''
                    }
                } else {
                    this.newAddress.district = ''
                }
            } else {
                this.newAddress.district = ''
            }
        },
        async saveAddress() {
            if (!this.newAddress.name || !this.newAddress.phone || !this.newAddress.province_code || !this.newAddress.city_code || !this.newAddress.district_code || !this.newAddress.detail) {
                ElMessage.warning('请填写完整的地址信息')
                return
            }
            
            this.loading = true;
            
            if (!this.newAddress.district && this.newAddress.district_code) {
                const province = this.areaData.find(item => item.code === this.newAddress.province_code)
                if (province) {
                    const city = province.children.find(item => item.code === this.newAddress.city_code)
                    if (city) {
                        const district = city.children.find(item => item.code === this.newAddress.district_code)
                        if (district) {
                            this.newAddress.district = district.name
                        }
                    }
                }
            }
            
            try {
                let res;
                if (this.editingAddressIndex >= 0) {
                    // 修改地址
                    res = await this.$axios.post('/api/yunsys.Order/updateaddress', {
                        id: this.addressList[this.editingAddressIndex].id,
                        name: this.newAddress.name,
                        phone: this.newAddress.phone,
                        province: this.newAddress.province,
                        province_code: this.newAddress.province_code,
                        city: this.newAddress.city,
                        city_code: this.newAddress.city_code,
                        district: this.newAddress.district,
                        district_code: this.newAddress.district_code,
                        detail: this.newAddress.detail,
                        is_default: this.newAddress.isDefault ? 1 : 0
                    });
                } else {
                    // 新增地址
                    res = await this.$axios.post('/api/yunsys.Order/addaddress', {
                        name: this.newAddress.name,
                        phone: this.newAddress.phone,
                        province: this.newAddress.province,
                        province_code: this.newAddress.province_code,
                        city: this.newAddress.city,
                        city_code: this.newAddress.city_code,
                        district: this.newAddress.district,
                        district_code: this.newAddress.district_code,
                        detail: this.newAddress.detail,
                        is_default: this.newAddress.isDefault ? 1 : 0
                    });
                }
                
                const data = res.data;
                if (data.code !== 0) {
                    ElMessage.error(data.msg || '保存地址失败');
                    return;
                }
                
                if (this.newAddress.isDefault) {
                    this.addressList.forEach(addr => addr.isDefault = false)
                }
                
                if (this.editingAddressIndex >= 0) {
                    // 更新现有地址，使用后台返回的数据
                    this.addressList[this.editingAddressIndex] = { 
                        ...this.addressList[this.editingAddressIndex],
                        ...data.data 
                    };
                    ElMessage.success('地址修改成功')
                } else {
                    // 添加新地址，使用后台返回的数据（包含id）
                    this.addressList.push({ ...data.data })
                    this.selectedAddressIndex = this.addressList.length - 1
                    ElMessage.success('地址添加成功')
                }
            } catch (err) {
                console.error('保存地址失败:', err);
                ElMessage.error('系统错误');
            } finally {
                this.loading = false;
            }
            
            this.resetAddressForm()
        },
        resetAddressForm() {
            this.newAddress = {
                name: '',
                phone: '',
                province: '',
                province_code: '',
                city: '',
                city_code: '',
                district: '',
                district_code: '',
                detail: '',
                isDefault: false
            }
            this.cityList = []
            this.districtList = []
            this.showAddAddress = false
            this.editingAddressIndex = -1
        },
        openAddAddress() {
            this.resetAddressForm()
            this.showAddAddress = true
        },
        editAddress(index) {
            const addr = this.addressList[index]
            // 直接设置所有数据
            this.newAddress = {
                name: addr.name,
                phone: addr.phone,
                province: addr.province,
                province_code: String(addr.province_code || ''),
                city: addr.city,
                city_code: String(addr.city_code || ''),
                district: addr.district,
                district_code: String(addr.district_code || ''),
                detail: addr.detail,
                isDefault: addr.isDefault
            }
            this.editingAddressIndex = index
            
            // 先根据省代码加载城市列表
            if (this.newAddress.province_code) {
                const province = this.areaData.find(item => item.code === this.newAddress.province_code)
                if (province) {
                    this.cityList = province.children || []
                    // 根据市代码加载区县列表
                    if (this.newAddress.city_code && province.children) {
                        const city = province.children.find(item => item.code === this.newAddress.city_code)
                        if (city) {
                            this.districtList = city.children || []
                        }
                    }
                }
            }
            
            this.showAddAddress = true
        },
        async deleteAddress(index) {
            const addr = this.addressList[index]
            try {
                await ElMessageBox.confirm('确定要删除该地址吗？', '确认删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                
                this.loading = true
                const res = await this.$axios.post('/api/yunsys.Order/deleteaddress', {
                    id: addr.id
                })
                
                const data = res.data
                if (data.code !== 0) {
                    ElMessage.error(data.msg || '删除地址失败')
                    return
                }
                
                this.addressList.splice(index, 1)
                if (this.selectedAddressIndex === index) {
                    this.selectedAddressIndex = Math.max(0, this.addressList.length - 1)
                }
                ElMessage.success('地址删除成功')
            } catch (err) {
                if (err !== 'cancel') {
                    console.error('删除地址失败:', err)
                    ElMessage.error('系统错误')
                }
            } finally {
                this.loading = false
            }
        },
        async getAddressList() {
            try {
                const res = await this.$axios.post('/api/yunsys.Order/getaddress')
                const data = res.data
                if (data.code !== 0) {
                    ElMessage.error(data.msg || '获取地址列表失败')
                    return
                }
                this.addressList = data.data || []
            } catch (err) {
                console.error('获取地址列表失败:', err)
                ElMessage.error('系统错误')
            }
        },
        handlePay() {
            if (this.tableData.length === 0) {
                //ElMessage.warning('购买清单为空，无法创建订单');
                //return;
            }
            if (this.selectedAddressIndex < 0) {
                ElMessage.warning('请选择收货地址');
                return;
            }
            this.transferInfo.paymentAmount = this.finalTotal.toFixed(2);
            this.showPayDialog = true;
        },
        async confirmPay() {
            if (this.confirmPayLoading) {
                return;
            }
            
            this.confirmPayLoading = true;
            
            try {
                if (this.paymentMethod === 'dg') {
                    // 对公支付，先验证必填项
                    if (!this.transferInfo.companyName) {
                        ElMessage.warning('请输入付款公司名称');
                        this.confirmPayLoading = false;
                        return;
                    }
                    if (!this.transferInfo.paymentAmount) {
                        ElMessage.warning('请输入付款金额');
                        this.confirmPayLoading = false;
                        return;
                    }
                    // 验证金额格式
                    const regex = /^\d+(\.\d{1,2})?$/;
                    if (!regex.test(this.transferInfo.paymentAmount)) {
                        ElMessage.warning('付款金额格式不正确，最多两位小数');
                        this.confirmPayLoading = false;
                        return;
                    }
                    // 对公支付，请求接口
                    const selectedAddress = this.addressList[this.selectedAddressIndex];
                    let payType = 1;
                    if (this.paymentMethod === 'alipay') {
                        payType = 2;
                    } else if (this.paymentMethod === 'dg') {
                        payType = 3;
                    }
                    const res = await this.$axios.post('/api/yunsys.Order/paybills', {
                        pay_no: this.orderNo,
                        address_id: selectedAddress?.id,
                        remark: this.orderRemark,
                        pay_type: payType,
                        freight_type:this.deliveryMethod==='express'?1:2,
                        pay_company_name: this.transferInfo.companyName,
                        pay_amount: this.transferInfo.paymentAmount,
                        pay_voucher: this.paymentVoucherList.map(item => item.url)
                    });
                    const data = res.data;
                    
                    if (data.code !== 0) {
                        ElMessage.error(data.msg || '支付请求失败');
                        return;
                    }
                    
                    this.showPayDialog = false;
                    this.showCorporateInfoDialog = true;
                } else {
                    // 微信支付或支付宝支付
                    const selectedAddress = this.addressList[this.selectedAddressIndex];
                    let payType = 1; // 微信支付
                    if (this.paymentMethod === 'alipay') {
                        payType = 2; // 支付宝支付
                    }
                    
                    // 模拟接口请求
                    const res = await this.$axios.post('/api/yunsys.Order/paybills', {
                        pay_no: this.orderNo,
                        address_id: selectedAddress?.id,
                        remark: this.orderRemark,
                        pay_type: payType,
                        freight_type:this.deliveryMethod==='express'?1:2
                    });
                    const data = res.data;
                    
                    if (data.code !== 0) {
                        ElMessage.error(data.msg || '支付请求失败');
                        return;
                    }
                    
                    this.showPayDialog = false;
                    
                    // 获取后台返回的支付信息
                    const payInfo = data.data || {};
                    console.log(payInfo,1111)
                    // 根据支付方式处理
                    if (this.paymentMethod === 'wechat') {
                        // 微信支付 - 显示二维码弹窗
                        const payUrl = payInfo;
                        if (payUrl) {
                            this.wechatPayUrl = payUrl;
                            this.wechatPayAmount = this.finalTotal;
                            this.showWechatPayDialog = true;
                            this.startPaymentPolling();
                        } else if (payInfo.prepay_id) {
                            // JSAPI支付 - 调用微信SDK（实际项目中需要引入微信JSAPI）
                            ElMessage.info('微信JSAPI支付需要在微信环境中使用');
                        } else {
                            ElMessage.warning('未获取到微信支付信息');
                            return;
                        }
                    } else if (this.paymentMethod === 'alipay') {
                        // 支付宝支付
                        const payUrl = payInfo.pay_url || payInfo.alipay_pay_url;
                        if (payUrl) {
                            window.open(payUrl, '_blank');
                        } else {
                            let htmlContent = payInfo.html_content || payInfo;
                            // 检查是否是 HTML 字符串
                            if (typeof htmlContent === 'string' && htmlContent.includes('<form') && htmlContent.includes('alipaysubmit')) {
                                // 在新窗口中打开并提交表单
                                const newWindow = window.open('', '_blank');
                                if (newWindow) {
                                    newWindow.document.write(htmlContent);
                                    newWindow.document.close();
                                } else {
                                    // 如果无法打开新窗口，当前页面提交
                                    const div = document.createElement('div');
                                    div.innerHTML = htmlContent;
                                    document.body.appendChild(div);
                                    const form = div.querySelector('form');
                                    if (form) form.submit();
                                }
                            } else {
                                ElMessage.warning('未获取到支付宝支付信息');
                                return;
                            }
                        }
                    }
                    
                    // 支付宝支付询问用户是否支付成功
                    if (this.paymentMethod === 'alipay') {
                        this.askPaymentStatus();
                    }
                }
            } catch (err) {
                console.error('支付请求失败:', err);
                ElMessage.error('系统错误');
            } finally {
                this.confirmPayLoading = false;
            }
        },
        closeWechatPayDialog() {
            this.showWechatPayDialog = false;
            this.clearPaymentPolling();
        },
        async checkWechatPayment() {
            this.clearPaymentPolling();
            this.showWechatPayDialog = false;
            this.$router.push('/user?type=orderList');
        },
        startPaymentPolling() {
            this.clearPaymentPolling();
            this.paymentPollingTimer = setInterval(() => {
                this.checkPaymentStatus();
            }, 2000);
        },
        clearPaymentPolling() {
            if (this.paymentPollingTimer) {
                clearInterval(this.paymentPollingTimer);
                this.paymentPollingTimer = null;
            }
        },
        async checkPaymentStatus() {
            try {
                const res = await this.$axios.post('/api/yunsys.Order/getbills', { pay_no: this.orderNo });
                const data = res.data;
                
                if (data.code !== 0) {
                    return;
                }
                
                const order = data.data;
                if (order.state !== 0) {
                    this.clearPaymentPolling();
                    this.showWechatPayDialog = false;
                    ElMessage.success('支付成功！');
                    this.$router.push('/user?type=orderList');
                }
            } catch (err) {
                console.error('检查支付状态失败:', err);
            }
        },
        async askPaymentStatus() {
            try {
                await ElMessageBox.confirm(
                    '请在新打开的支付页面完成支付，支付完成后请确认支付状态。',
                    '支付确认',
                    {
                        confirmButtonText: '支付成功',
                        cancelButtonText: '支付遇到问题',
                        type: 'info',
                        distinguishCancelAndClose: true
                    }
                );
                
                // 用户点击支付成功
                ElMessage.success('支付成功！');
                this.$router.push('/user?type=orderList');
            } catch (action) {
                if (action === 'cancel') {
                    // 用户点击支付遇到问题
                    ElMessage.warning('支付遇到问题，您可以稍后重试');
                } else {
                    // 用户关闭对话框
                    ElMessage.info('您可以稍后在订单中心查看订单状态');
                }
            }
        },
        header_table(event) {
            if (event.column.property == 'header') {
                return { 'background-color': '#fff' }
            } else {
                return { 'background-color': '#e5e5e5' }
            }

        },
       
        tableHeight_fun() {
            this.$nextTick(() => {
                this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 50
                console.log(this.tableHeight)
            })
        },
        async search() {
            const pay_no = this.$route.query.pay_no;
            if (!pay_no) {
                ElMessage.warning('未获取到订单号');
                return;
            }
            
            this.loading = true;
            try {
                const res = await this.$axios.post('/api/yunsys.Order/getbills', { pay_no });
                const data = res.data;
                
                if (data.code !== 0) {
                    ElMessage.error(data.msg || '获取订单详情失败');
                    return;
                }
                
                const order = data.data;
                
                // 检查订单状态，非待支付状态(1)时提示用户
                if (order.state  !== 0) {
                    ElMessageBox.alert(
                        '该订单当前状态不支持支付操作，请前往订单中心查看订单详情。',
                        '提示',
                        {
                            confirmButtonText: '去订单中心',
                            type: 'warning',
                            callback: () => {
                                this.$router.push('/user?type=orderList');
                            }
                        }
                    );
                    return;
                }
                
                // 填充订单号
                this.orderNo = order.pay_no || pay_no;
                // 保存订单关联的收货地址ID
                this.address_id = order.address_id || '';
                // 填充订单时间
                this.orderTime = order.create_time || new Date().toLocaleString('zh-CN');
                // 根据订单时间和服务器时间计算倒计时

                this.orderRemark = order.order_remark || '';
                
                // 从后台获取商品数量、快递费用、商品金额（后台返回字符串，需转为数字）
                this.totalQuantity = Number(order.total_num) || 0;
                this.shippingFee = Number(order.freight_fee) || 0;
                this.totalAmount = Number(order.total_goods_sum) || 0;
                this.totalSum = Number(order.total_sum) || 0;
                this.goodsDiscount = Number(order.goods_discount) || 0;
                // 从后台获取快递方式默认值，1表示快递，2表示到付
                if (order.freight_type === 2) {
                    this.deliveryMethod = 'cod';
                } else {
                    this.deliveryMethod = 'express';
                }
                this.corporateAccount= {
                    bankName: order.open_bank || '',
                    accountName: order.bank_name || '',
                    accountNumber: order.bank_no || ''
                };
                
                // 填充购买清单
                this.tableData = order.product || [];
                this.tableData.forEach(item => {
                        item.stock_type_txt_list = item.stock_type_txt.split("、");
                    });
            } catch (err) {
                console.error('获取订单详情失败:', err);
                ElMessage.error('系统错误');
            } finally {
                this.loading = false;
            }
        },

        editAddress(index) {
            const addr = this.addressList[index]
            this.newAddress = {
                name: addr.name,
                phone: addr.phone,
                province: addr.province,
                province_code: addr.province_code || '',
                city: addr.city,
                city_code: addr.city_code || '',
                district: addr.district,
                district_code: addr.district_code || '',
                detail: addr.detail,
                isDefault: addr.isDefault
            }
            console.log(this.newAddress ,111 )    
            // 重新加载城市和区县列表
            if (this.newAddress.province_code) {
                this.handleProvinceChange(this.newAddress.province_code)
                this.$nextTick(() => {
                       // this.newAddress.city_code = addr.city_code || ''
                    })
                if (this.newAddress.city_code) {
                    this.$nextTick(() => {
                        this.handleCityChange(this.newAddress.city_code)
                    })
                }
            }
            this.editingAddressIndex = index
            this.showAddAddress = true
        },
        async deleteAddress(index) {
            const addr = this.addressList[index]
            try {
                await ElMessageBox.confirm('确定要删除该地址吗？', '确认删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                
                this.loading = true
                const res = await this.$axios.post('/api/yunsys.Order/deleteaddress', {
                    id: addr.id
                })
                
                const data = res.data
                if (data.code !== 0) {
                    ElMessage.error(data.msg || '删除地址失败')
                    return
                }
                
                this.addressList.splice(index, 1)
                if (this.selectedAddressIndex === index) {
                    this.selectedAddressIndex = Math.min(index, this.addressList.length - 1)
                }
                ElMessage.success('地址删除成功')
            } catch (err) {
                if (err !== 'cancel') {
                    console.error('删除地址失败:', err)
                    ElMessage.error('系统错误')
                }
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
<style lang="less" scoped>
.order-detail-page {
    background: #f5f7fa;
    padding: 10px 5px 3px 4px;
}



.order-section {
    background: #fff;
    border-radius: 12px;
    padding: 12px 24px 12px 24px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding-bottom: 12px;
    display: flex;
    align-items: center;

    &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 16px;
        background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
        border-radius: 2px;
        margin-right: 10px;
    }
}

.order-info {
    background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #ffe4d6;
}

.countdown-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 20px;
    background: linear-gradient(135deg, #fff5f0 0%, #ffe8dc 100%);
    border-radius: 25px;
    margin-bottom: 16px;
    border: 1px solid #ffd4c4;
    transition: all 0.3s ease;
    
    &.urgent {
        background: linear-gradient(135deg, #fff2f0 0%, #ffccc7 100%);
        border-color: #ff4d4f;
        animation: pulse 1.5s ease-in-out infinite;
    }
    
    .countdown-icon {
        font-size: 18px;
    }
    
    .countdown-label {
        font-size: 14px;
        color: #666;
        font-weight: 500;
    }
    
    .countdown-time {
        font-size: 20px;
        font-weight: 700;
        color: #ff8a5c;
        font-family: 'Courier New', monospace;
        min-width: 60px;
        text-align: center;
        
        &:before {
            content: '';
            width: 100%;
            height: 100%;
        }
    }
    
    &.urgent .countdown-time {
        color: #ff4d4f;
    }
}

@keyframes pulse {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.4);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(255, 77, 79, 0);
    }
}

.info-item {
    font-size: 14px;
}

.info-label {
    color: #666;
    margin-right: 8px;
}

.info-value {
    color: #ff8a5c;
    font-weight: 600;
    font-family: 'Courier New', monospace;
}

.delivery-method,
.payment-method {
    .el-radio-group {
        display: flex;
        gap: 16px;
    }

    .el-radio {
        margin: 0;
    }

    .radio-content {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 2px 10px;
        border: 2px solid #e8e8e8;
        border-radius: 8px;
        transition: all 0.3s ease;
        cursor: pointer;
    }

    .el-radio.is-checked .radio-content {
        border-color: #ff8a5c;
        background: #fff5f0;
    }

    .radio-icon {
        font-size: 24px;
    }
}

/* 收货地址显示 */
.address-display {
    display: flex;
    align-items: center;
    padding: 6px 16px 6px 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #f5f7fa;
    border: 2px solid #e4e7ed;
    position: relative;
    overflow: hidden;
}

.address-corner {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, transparent 50%, #ff8a5c 50%);
}

.address-corner::after {
    content: '';
    position: absolute;
    top: 2px;
    right: 2px;
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, transparent 50%, #f5f7fa 50%);
}

.address-icon {
    color: #ff8a5c;
    font-size: 22px;
    margin-right: 12px;
    flex-shrink: 0;
    min-width: 22px;
    min-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.edit-icon {
    position: absolute;
    top: 4px;
    right: 4px;
    color: #ff8a5c;
    font-size: 14px;
    z-index: 10;
}

.address-display:hover {
    border-color: #ff8a5c;
    box-shadow: 0 2px 8px rgba(255, 138, 92, 0.2);
}

.address-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
}

.address-placeholder {
    color: #999;
    font-size: 14px;
    display: flex;
    align-items: center;
}

.address-name {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
}

.address-detail-text {
    font-size: 13px;
    color: #666;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 弹窗内地址列表样式 */
.address-list {
    max-height: 350px;
    overflow-y: auto;
}

.address-item {
    display: flex;
    flex-direction: column;
    padding: 16px;
    border: 2px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 12px;
    transition: all 0.3s ease;
    background: #fafafa;
    position: relative;
}

.address-item:hover {
    border-color: #ff8a5c;
    background: #fff;
}

.address-item.active {
    border-color: #ff8a5c;
    background: #fff8f5;
}

.address-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
}

.address-info-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
}

.address-item .address-name {
    font-size: 15px;
    font-weight: 600;
    color: #333;
}

.address-item .address-phone {
    font-size: 14px;
    color: #666;
}

.address-item .address-detail {
    font-size: 13px;
    color: #999;
    line-height: 1.5;
    margin-bottom: 10px;
    word-break: break-all;
}

.address-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.default-tag {
    background: #ff8a5c;
    color: #fff;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
}

.action-buttons {
    display: flex;
    gap: 8px;
}

.no-address-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #999;
    font-size: 14px;
    gap: 10px;
}

.no-address-tip .el-icon {
    font-size: 32px;
}

.add-address-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    border: 2px dashed #ddd;
    border-radius: 8px;
    cursor: pointer;
    margin-top: 10px;
    color: #999;
    font-size: 14px;
    transition: all 0.3s ease;
}

.add-address-btn:hover {
    border-color: #ff8a5c;
    color: #ff8a5c;
}

.edit-btn,
.delete-btn {
    padding: 2px 8px;
    font-size: 12px;
}

.edit-btn {
    background: #fff;
    border-color: #ff8a5c;
    color: #ff8a5c;
    
    &:hover {
        background: #fff5f0;
        border-color: #ff6b3d;
        color: #ff6b3d;
    }
}

.delete-btn {
    background: #fff;
    border-color: #ff4d4f;
    color: #ff4d4f;
    
    &:hover {
        background: #fff1f0;
        border-color: #ff7875;
        color: #ff7875;
    }
}

.purchase-list {
    .scroll-container {
        border-radius: 8px;
    }
}

.remark-section {
    :deep(.el-textarea__inner) {
        border-radius: 8px;
        padding: 12px;
    }
}

.order-summary {
    .summary-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;
        font-size: 14px;
    }

    .summary-label {
        color: #666;
    }

    .summary-value {
        color: #333;
    }

    .summary-divider {
        height: 1px;
        background: #e8e8e8;
        margin: 8px 0;
    }

    .total-item {
        padding-top: 12px;
        font-size: 16px;
    }

    .total-value {
        color: #ff8a5c;
        font-weight: 700;
        font-size: 20px;
    }

    .discount {
        color: #ff4d4f;
        font-weight: 700;
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 4px;
        .el-tag {
            font-size: 11px;
            padding: 0 6px;
            height: 20px;
            line-height: 20px;
            border-radius: 3px;
        }
    }

    .address-summary {
        .address-text {
            text-align: right;
            max-width: 400px;
        }
    }
}

.order-footer {
    background: #fff;
    border-radius: 12px;
    padding: 20px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
    position: sticky;
    bottom: 0;
    z-index: 100;
}

.footer-left {
    .total-display {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .total-label {
        font-size: 14px;
        color: #666;
    }

    .total-amount {
        font-size: 28px;
        font-weight: 700;
        color: #ff8a5c;
    }
}

.pay-btn {
    background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
    border: none;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    padding: 14px 48px;
    box-shadow: 0 4px 12px rgba(255, 138, 92, 0.4);
    transition: all 0.3s ease;

    &:hover {
        background: linear-gradient(135deg, #ff6b3d 0%, #ff5a2b 100%);
        box-shadow: 0 6px 16px rgba(255, 138, 92, 0.5);
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(255, 138, 92, 0.4);
    }

    &.is-disabled {
        background: #d9d9d9;
        box-shadow: none;
        cursor: not-allowed;
        transform: none;
        
        &:hover {
            background: #d9d9d9;
            box-shadow: none;
            transform: none;
        }
    }
}

.delete-btn {
    background: #fff;
    border: 1px solid #ff4d4f;
    color: #ff4d4f;
    font-size: 14px;
    font-weight: 500;
  //  padding: 12px 24px;
    margin-right: 2px;
    transition: all 0.3s ease;

    &:hover {
        background: #fff1f0;
        border-color: #ff7875;
        color: #ff7875;
    }

    &:active {
        background: #fff1f0;
    }
}

:deep(.el-table__header .el-table__cell) {
    // border: none;
}

:deep(.el-table__header .el-table__cell) {
    //border: none;
}

:deep(thead tr:first-child .cell) {
    padding: 0px
}

:deep(.el-table__row .el-table__cell:nth-child(2)) {
    .el-tooltip {
        padding: 0px;
    }
}

.stock_type_txt_button .el-button {
    margin-right: 5px;
    font-size: 0.70rem !important;
    padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
    color: red !important   ;
    background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .B {
    color: red;
    background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
    color: rgb(75, 212, 205);
    background-color: rgb(223, 255, 251) !important;
}

:deep(.el-input-group__append) {
    background: #ff8a5c;
}

:deep(.num-input .el-input__wrapper) {
    box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color)) inset !important;
}


:deep(.district .el-input-group__prepend) {
    background-color: #fff;
    color: #ff8a5c;
}

:deep(.district .el-input-group__append) {
    background-color: #fff;
    color: #ff8a5c;
}

:deep(.el-image) {
    border-radius: 3px;
    height: 100px;
    width: 100px;
    display: inline-block;
    display: flex;
}

:deep(.acquiesce .el-button) {

    border: 0;
}

:deep(.info .el-button:hover) {
    color: #fff;
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

:deep(.name .el-button:hover) {
    color: #ff8a5c;
}

.pay-dialog-content {
    .dialog-section {
        margin-bottom: 24px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    .dialog-section-title {
        font-size: 15px;
        font-weight: 600;
        color: #333;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        align-items: center;
        &::before {
            content: '';
            display: inline-block;
            width: 3px;
            height: 14px;
            background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
            border-radius: 2px;
            margin-right: 8px;
        }
    }

    .order-info-block,
    .address-info-block,
    .payment-info-block {
        background: #fafafa;
        border-radius: 8px;
        padding: 16px;
    }

    .info-row {
        display: flex;
        padding: 6px 0;
        font-size: 14px;
        &.total-row {
            padding-top: 12px;
            margin-top: 8px;
            border-top: 1px dashed #e0e0e0;
            display: flex;
        align-items: center;
        }
        &.address-row {
            align-items: flex-start;
            .address-text {
                flex: 1;
                line-height: 1.6;
            }
        }
    }

    .info-label {
        color: #666;
        min-width: 80px;
    }

    .info-value {
        color: #333;
        flex: 1;
        &.order-no {
            font-family: 'Courier New', monospace;
            font-weight: 500;
        }
        &.total-price {
            color: #ff8a5c;
            font-size: 22px;
            font-weight: 700;
        }
    }

    .payment-method-display {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 8px;
        border: 2px solid #ff8a5c;
        background: #fff5f0;
        &.wechat {
            border-color: #15ba11;
            background: #f0fff0;
            .payment-icon {
               
                border-radius: 4px;
            }
        }
        &.alipay {
            border-color: #009fe8;
            background: #f0f8ff;
            .payment-icon {
               
                border-radius: 4px;
            }
        }
        &.corporate {
            border-color: #fc5330;
            background: #fff5f2;
            .payment-icon {
                border-radius: 4px;
            }
        }
        .payment-name {
            font-size: 14px;
            font-weight: 600;
            color: #333;
        }
    }

    .corporate-info {
        padding: 16px;
        background: #fff5f2;
        border-radius: 8px;
        border: 1px solid #ffe0d6;

        .corporate-title {
            font-size: 14px;
            font-weight: 600;
            color: #fc5330;
            margin-bottom: 12px;
            padding-bottom: 8px;
            border-bottom: 1px dashed #ffe0d6;
        }

        .corporate-row {
            display: flex;
            padding: 6px 0;
            font-size: 14px;

            .corporate-label {
                color: #666;
                min-width: 80px;
            }

            .corporate-value {
                color: #333;
                flex: 1;
                font-weight: 500;
            }
        }

        .corporate-divider {
            height: 1px;
            background: #ffe0d6;
            margin: 16px 0;
        }

        .transfer-info-title {
            font-size: 14px;
            font-weight: 600;
            color: #fc5330;
            margin-bottom: 12px;
        }

        .transfer-info-row {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            &:last-child {
                margin-bottom: 0;
            }
            .transfer-label {
                color: #666;
                min-width: 130px;
                font-size: 14px;
                display: flex;
                align-items: center;
                position: relative;
                padding-left: 14px;
                .required {
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #ff4d4f;
                }
            }
            .transfer-input {
                flex: 1;
            }
            .voucher-uploader {
                :deep(.el-upload--picture-card) {
                    width: 80px;
                    height: 80px;
                }
                :deep(.el-upload-list--picture-card .el-upload-list__item) {
                    width: 80px;
                    height: 80px;
                }
                .voucher-uploader-icon {
                    font-size: 24px;
                    color: #8c939d;
                }
            }
        }

        .transfer-tip {
            margin-top: 4px;
            padding: 8px 0px;
            background: #fff7f2;
            color: #fc5330;
            font-size: 13px;
            line-height: 1.6;
            border-radius: 2px;
        }

        .remark-section {
            margin-top: 12px;
            padding-top: 12px;
            border-top: 1px dashed #ffe0d6;

            .remark-label {
                font-size: 14px;
                color: #fc5330;
                font-weight: 500;
            }

            .remark-example {
                display: inline-block;
                margin-top: 8px;
                padding: 8px 12px;
                background: #fff;
                border-radius: 4px;
                border: 1px solid #fc5330;
                color: #fc5330;
                font-size: 13px;
                font-family: 'Courier New', monospace;
            }
        }
    }
}

:deep(.confirm-pay-btn) {
    background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
    border: none;
    padding: 10px 32px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 20px;
    &:hover {
        background: linear-gradient(135deg, #ff6b3d 0%, #ff5a2b 100%);
    }
}

:deep(.name .el-button:active) {
    color: #ff8a5c;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
    background-color: #ff8a5c;
}

:deep(.el-form-item__label) {
    font-size: 13px;
}

:deep(.el-form-item) {

    margin-bottom: 8px;
}

:deep(.el-input-group__append) {

    background: #ff8a5c;
}

.logo_m {
    margin: 15px 0px 15px 0px;
    height: auto;
}



.product-tags {
    margin-bottom: 6px;
}

.product-tags .el-tag {
    margin-right: 6px;
    margin-bottom: 4px;
}

.brand-name {
    font-weight: bold;
    color: #333;
    font-size: 14px;
    margin-bottom: 4px;
}

.product-name {
    color: #666;
    font-size: 13px;
    margin-bottom: 4px;
}

.product-details {
    color: #999;
    font-size: 12px;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
}

.detail-label {
    display: inline-block;
    width: 48px;
    text-align: justify;
    text-align-last: justify;
    text-justify: inter-character;
}

.label-colon {
    margin-right: 8px;
}

.detail-value {
    flex: 1;
}

.product-user-type {
    color: #666;
    font-size: 12px;
    margin-top: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.price-value {
    color: #ff8a5c;
    font-size: 16px;
    font-weight: bold;
}

.price-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.corporate-info-dialog {
    text-align: center;
    
    .success-icon {
        font-size: 48px;
        margin-bottom: 12px;
        animation: bounceIn 0.6s ease;
    }
    
    .success-message {
        font-size: 18px;
        font-weight: 600;
        color: #52c41a;
        margin-bottom: 24px;
    }
    
    .corporate-info-section {
            background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
            border: 1px solid #ffe0d6;
            border-radius: 12px;
            padding: 20px;
            margin-bottom: 0;
            text-align: left;
            
            .corporate-title {
                font-size: 15px;
                font-weight: 600;
                color: #ff8a5c;
                margin-bottom: 16px;
                padding-bottom: 12px;
                border-bottom: 2px dashed #ffe0d6;
                display: flex;
                align-items: center;
                justify-content: center;
                
                &::before {
                    margin-right: 8px;
                }
            }
            
            .corporate-row {
                display: flex;
                padding: 10px 0;
                font-size: 14px;
                border-bottom: 1px solid #fff0e8;
                
                &:last-child {
                    border-bottom: none;
                }
                
                .corporate-label {
                    color: #666;
                    min-width: 90px;
                    font-weight: 500;
                }
                
                .corporate-value {
                    color: #333;
                    flex: 1;
                    font-weight: 600;
                    font-family: 'Courier New', monospace;
                    word-break: break-all;
                }
            }
        }
        
        .corporate-divider {
            height: 1px;
            background: linear-gradient(90deg, transparent, #ffe0d6, transparent);
            margin: 20px 0;
        }
        
        .transfer-info-section {
            background: linear-gradient(135deg, #f0f8ff 0%, #fff 100%);
            border: 1px solid #b3d9ff;
            border-radius: 12px;
            padding: 20px;
            margin-bottom: 20px;
            text-align: left;
            
            .transfer-title {
                font-size: 15px;
                font-weight: 600;
                color: #0066cc;
                margin-bottom: 16px;
                padding-bottom: 12px;
                border-bottom: 2px dashed #b3d9ff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            
            .transfer-row {
                display: flex;
                padding: 10px 0;
                font-size: 14px;
                border-bottom: 1px solid #e6f2ff;
                
                &:last-child {
                    border-bottom: none;
                }
                
                .transfer-label {
                    color: #666;
                    min-width: 110px;
                    font-weight: 500;
                }
                
                .transfer-value {
                    color: #333;
                    flex: 1;
                    font-weight: 600;
                    font-family: 'Courier New', monospace;
                    word-break: break-all;
                }
            }
        }
    
    .warning-section {
        line-height: 20px;
        background: linear-gradient(135deg, #fff7e6 0%, #fff 100%);
        border: 1px solid #ffd591;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 20px;
        display: flex;
        align-items: flex-start;
        gap: 12px;
        
        .warning-icon {
            font-size: 24px;
            flex-shrink: 0;
        }
        
        .warning-text {
            flex: 1;
            text-align: left;
            font-size: 14px;
            color: #fa8c16;
            font-weight: 500;
            line-height: 1.6;
        }
    }
    
    .remark-info {
        background: #f6ffed;
        border: 1px solid #b7eb8f;
        border-radius: 12px;
        padding: 16px;
        text-align: left;
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
        
        .remark-label {
            font-size: 14px;
            color: #389e0d;
            font-weight: 500;
            flex-shrink: 0;
        }
        
        .remark-example {
            display: inline-block;
            padding: 8px 16px;
            background: #fff;
            border: 2px solid #52c41a;
            border-radius: 8px;
            color: #389e0d;
            font-size: 15px;
            font-weight: 600;
            font-family: 'Courier New', monospace;
            letter-spacing: 1px;
            flex-shrink: 0;
        }
    }
}

@keyframes bounceIn {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

:deep(.el-dialog__header) {
   // background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
//padding: 16px 20px;
    
    .el-dialog__title {
       // color: #fff;
        font-weight: 600;
        font-size: 16px;
    }
    
    .el-dialog__headerbtn {
        .el-dialog__close {
            //color: #fff;
            font-size: 20px;
            
            &:hover {
                color: #333;
                opacity: 0.8;
            }
        }
    }
}

.inquiry-btn {
    color: #ff8a5c;
    font-size: 13px;
    padding: 0;
}

.inquiry-btn:hover {
    color: #ff6b3d;
}

.off-shelf {
    color: #999;
    font-size: 12px;
}

.stock-cell {
    //display: flex;

    height: 100%;
}

.stock-value {
    font-size: 13px;
    color: #333;
}

/* 底部合计区域样式 */
.footer-bar {
    background: #fff;
    border-top: 1px solid #e8e8e8;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.footer-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
}

.total-section {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
}

.total-label {
    font-size: 14px;
    color: #666;
    font-weight: 500;
    white-space: nowrap;
}

.total-amount {
    font-size: 24px;
    color: #ff8a5c;
    font-weight: bold;
    white-space: nowrap;
}

.pay-btn {
    background: linear-gradient(135deg, #ff8a5c 0%, #ff6b3d 100%);
    border: none;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding: 12px 36px;
    box-shadow: 0 4px 12px rgba(255, 138, 92, 0.4);
    transition: all 0.3s ease;
}

.pay-btn:hover {
    background: linear-gradient(135deg, #ff6b3d 0%, #ff5a2b 100%);
    box-shadow: 0 6px 16px rgba(255, 138, 92, 0.5);
    transform: translateY(-2px);
}

.pay-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(255, 138, 92, 0.4);
}

.chat-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected) td {
    border-top: 1px solid #ff8a5c !important;
    border-bottom: 1px solid #ff8a5c !important;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected td:first-child) {
    border-left: 1px solid #ff8a5c !important;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected td:last-child) {
    border-right: 1px solid #ff8a5c !important;
}

/* 多选框选中颜色 */
:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

/* 多选框移入边框颜色 */
:deep(.el-checkbox__input:hover .el-checkbox__inner) {
    border-color: #ff8a5c;
}

/* 小屏幕 (平板, 768px 及以上) */
@media (min-width: 768px) {
    .search_remark {
        width: 120px;
    }
}

/* 中等屏幕 (桌面, 992px 及以上) */
@media (min-width: 992px) {
    .search_remark {
        width: 170px;
    }
}

/* 大屏幕 (大桌面, 1600px 及以上) */
@media (min-width: 1600px) {
    .search_remark {
        width: 400px;
        margin-left: 60px
    }
}

/* 超大屏幕 (更大桌面, 1920px 及以上) */
@media (min-width: 1920px) {
    .search_remark {
        width: 400px;
        margin-left: 60px
    }
}

/* 滚动条样式优化 */
/* Firefox 滚动条样式 */
:deep(.scroll-container) {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    transition: scrollbar-color 0.2s ease;
}

:deep(.scroll-container:hover) {
    scrollbar-color: #c9cdd4 transparent;
}

/* Chrome/Safari 滚动条样式 */
:deep(.scroll-container::-webkit-scrollbar) {
    width: 6px;
    height: 6px;
}

:deep(.scroll-container::-webkit-scrollbar-thumb) {
    background-color: #e5e6eb;
    border-radius: 6px;
    opacity: 0;
    transition: all 0.2s ease;
}

:deep(.scroll-container:hover::-webkit-scrollbar-thumb) {
    opacity: 1;
    background-color: #c9cdd4;
}

:deep(.scroll-container::-webkit-scrollbar-track) {
    background: transparent;
}

/* 微信支付弹窗样式 */
.wechat-pay-dialog {
    text-align: center;
    padding: 10px 0;
}

.wechat-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 24px;
}

.wechat-icon {
    display: flex;
    align-items: center;
    justify-content: center;
}

.wechat-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.amount-section {
    background: linear-gradient(135deg, #f8fff8 0%, #f0fff0 100%);
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 24px;
    border: 1px solid #d4f5d4;
}

.amount-label {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
}

.amount-value {
    font-size: 36px;
    font-weight: 700;
    color: #15BA11;
}

.qrcode-section {
    margin-bottom: 24px;
}

.qrcode-wrapper {
    display: inline-block;
    padding: 16px;
    background: #fff;
    border: 2px solid #e8e8e8;
    border-radius: 12px;
    margin-bottom: 12px;
}

.qrcode-tip {
    font-size: 14px;
    color: #999;
}

.order-info-section {
    background: #f9f9f9;
    padding: 12px 20px;
    border-radius: 8px;
}

.order-info-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.order-info-label {
    font-size: 14px;
    color: #666;
}

.order-info-value {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    font-family: 'Courier New', monospace;
}
</style>